import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * tailwind-merge only knows Tailwind's stock utilities. Our own ones fall
 * through to whichever group matches loosest — `border-hairline` reads as a
 * border *colour* and `text-dense` as a text *colour* — so pairing either with
 * a real colour silently dropped it. Registering them puts each in the group it
 * actually belongs to.
 */
const twMerge = extendTailwindMerge({
  prefix: 'sk',
  extend: {
    classGroups: {
      'border-w': ['border-hairline'],
      'font-size': ['text-dense', 'text-title'],
      tracking: ['tracking-dense'],
      rounded: ['rounded-card', 'rounded-option', 'rounded-panel'],
      shadow: ['shadow-card'],
      'inset-shadow': ['inset-shadow-hairline', 'inset-shadow-selected'],
    },
  },
});

/**
 * Merges class names and resolves conflicting Tailwind utilities so callers can
 * override a component's defaults through className.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
